import React, { lazy, useEffect, useState } from "react";
import axios from "../libs/axios";
const UserCard = lazy(() => import("./Participants/UserCard"));

const Winners = () => {
  const [winners, setWinners] = useState([]);
  const [year, setYear] = useState(null);

  useEffect(() => {
    axios.get("/content/winnerYear").then((res) => setYear(res.data));
  }, []);

  useEffect(() => {
    const fetchWinners = async () => {
      axios
        .get("/archive/winners", {
          year: year,
        })
        .then((res) => {
          setWinners(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    };

    fetchWinners();
  }, [year]);

  return (
    <div className="flex flex-col items-center">
      <h1 className="text-2xl mb-4 font-bold text-center">
        წინა წლის კამპანიის გამარჯვებულები
      </h1>
      <div className="grid box-border px-10 md:px-20 grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {winners.map((winner, _index) => (
          <UserCard
            key={_index}
            avatar_url={`${process.env.REACT_APP_EXPRESS_URL}${winner.avatar_url}`}
            name={winner.name}
            lastname={winner.lastname}
            fb={winner?.social?.fb}
            ig={winner?.social?.ig}
            tk={winner?.social?.tk}
            yt={winner?.social?.yt}
            isWinner={true}
            place={_index + 1}
          />
        ))}
      </div>
    </div>
  );
};

export default Winners;
